import React from 'react';
import NextLink from 'next/link';

const Link = ({ type, children, ...rest }) => (
  <NextLink prefetch={false} {...rest}>
    <a target={type && type !== 'internalPage' ? '_blank' : null} {...rest}>
      {children}
    </a>
  </NextLink>
);
export default Link;
